/**
 * Next highlighted index for header menu search arrow keys.
 * @param {number} current - current index, or -1 when nothing highlighted
 * @param {'down'|'up'} direction
 * @param {number} length - results length
 * @returns {number}
 */
export function nextSearchActiveIndex(current, direction, length) {
  const len = Number(length) || 0;
  if (len <= 0) return -1;
  const cur = Number(current);
  const idx = Number.isFinite(cur) ? cur : -1;
  if (direction === 'down') {
    if (idx < 0) return 0;
    return Math.min(idx + 1, len - 1);
  }
  if (direction === 'up') {
    if (idx < 0) return len - 1;
    return Math.max(idx - 1, 0);
  }
  return idx;
}

/**
 * Combobox Enter: confirm the highlighted row.
 * With a search query, Enter opens the first (or arrow/hover-highlighted) match
 * even when several rows remain. With an empty query, Enter only fires after
 * the user has armed a row (arrow keys or hover) so an accidental Enter does
 * not open the first estimate in the full list.
 */
export function pickHighlightedOnEnter(items, highlightIndex, { query, armed } = {}) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const hasQuery = Boolean(String(query || '').trim());
  if (!hasQuery && !armed) return null;
  const idx = Number(highlightIndex);
  const safe = Number.isFinite(idx) ? Math.min(Math.max(idx, 0), items.length - 1) : 0;
  return items[safe];
}
